var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSelectRule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8108 10.5078C12.0159 10.5078 10.5608 11.9629 10.5608 13.7578L10.5608 39.0502L10.5608 62.2988C10.5608 64.0938 12.0159 65.5488 13.8108 65.5488L62.3513 65.5488C64.1463 65.5488 65.6013 64.0938 65.6013 62.2988L65.6013 37.0065V13.7578C65.6013 11.9629 64.1463 10.5078 62.3513 10.5078H13.8108ZM32.827 13.0078H13.8108C13.3966 13.0078 13.0608 13.3436 13.0608 13.7578V62.2984C13.0608 62.7126 13.3966 63.0484 13.8108 63.0484H43.3351V63.0488H62.3513C62.7655 63.0488 63.1013 62.713 63.1013 62.2988L63.1013 13.7583C63.1013 13.3441 62.7655 13.0083 62.3513 13.0083L32.827 13.0083V13.0078Z",
    fill: "#CCCFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 4C36.5988 4 19.7237 4 5.99746 4C4.89289 4 4 4.89781 4 6.00238C4 25.02 4 29.9869 4 50",
    stroke: "#CCCFD1",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 46.5818L40.5577 49L57 30",
    stroke: "#CCCFD1",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 35.2545L31.1139 47L48 28",
    stroke: "#CCCFD1",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelectRule);
export default __webpack_public_path__ + "static/media/icon-select-rule.5a824011f78919fe65e3787a5a6b67d5.svg";
export { ForwardRef as ReactComponent };